module.exports = __webpack_public_path__ + "img/quilt-rank-time.c9f05868.png";